const theme = {
    colors :{

    },
    screens: {

    },
}
export default theme;